/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import * as t from "react";
import { useUnstyled as d, classNames as m, uForm as i } from "@progress/kendo-react-common";
const n = (e) => {
  const a = d(), s = e.unstyled || a, l = s && s.uForm, c = t.useMemo(
    () => m(
      i.field({
        c: l,
        isRtl: e.dir === "rtl"
      }),
      e.className
    ),
    [l, e.className, e.dir]
  );
  return /* @__PURE__ */ t.createElement("div", { className: c, style: e.style }, e.children);
};
n.displayName = "KendoReactFieldWrapper";
export {
  n as FieldWrapper
};
